import { Onglets } from '@components/onglets/models';
import { CostLevel } from '@shared/enums';
import { Block } from '@shared/models';

export const ongletsMock: Block<Onglets> = {
  type: 'onglets',
  data: {
    tabs: [
      {
        name: 'Je pose moi-même',
        costLevel: CostLevel.Low,
        url: '/mock-la-pose/perso',
      },
      {
        name: 'Je fais poser',
        costLevel: CostLevel.Medium,
        url: '/mock-la-pose/pro',
      },
    ],
  },
};
